Alpine.data('alpine_toggle', () => ({
  open: false,

  get isOpen() {
    return this.open;
  },

  toggle() {
    this.open = !this.open;
  },

  toggleOn() {
    this.open = true;
  },

  toggleOff() {
    this.open = false;
  },
}));
